import React from 'react';

const CheckIcon = () => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15.3438 3.15625C15.5312 3.34375 15.5312 3.6875 15.3438 3.875L6.84375 12.375C6.65625 12.5625 6.3125 12.5625 6.125 12.375L1.625 7.875C1.4375 7.6875 1.4375 7.34375 1.625 7.15625C1.8125 6.96875 2.15625 6.96875 2.34375 7.15625L6.5 11.3125L14.625 3.15625C14.8125 2.96875 15.1562 2.96875 15.3438 3.15625Z" />
  </svg>
);

export default CheckIcon;
